import { useQuery } from '@tanstack/react-query';
import { adsService } from '../services/ads.service';

export function useCampaignStats(refId: string | undefined) {
  return useQuery({
    queryKey: ['campaignStats', refId],
    queryFn: () => adsService.getCampaignStats(refId!),
    enabled: !!refId,
  });
}
